import { authService } from '../index';
import { httpPostAsync } from '../utils/HttpClient';
import { IApplication } from '../Interfaces/Application/IApplication';
import { ApplicationLeaseCalculationResult, LeaseCalcMode } from '../Interfaces/Application/ApplicationLeaseCalculationResult';

const SOLVE_FAILED = 'The lease quote could not be solved.';

/**
 * Asks the server to solve the application's lease quote, attaching newVehicleId first when given.
 * Validation and DB Sync problems come back in the result's errors; a refusal (lock, out-of-date page)
 * throws with the server's message.
 */
export const requestLeaseQuoteSolve = async (
  application: IApplication,
  mode: LeaseCalcMode,
  newVehicleId?: string
): Promise<ApplicationLeaseCalculationResult> => {
  const token = await authService.getToken();
  const vehicleParameter = newVehicleId ? `&newVehicleId=${newVehicleId}` : '';
  const response = await httpPostAsync(`api/applicationLeaseQuote/LeaseQuoteCalc?mode=${mode}${vehicleParameter}`, application, token);
  if (!response) {
    throw new Error(SOLVE_FAILED);
  }

  const body = await response.json().catch(() => undefined);
  if (!response.ok) {
    throw new Error(body?.message ?? body?.Message ?? SOLVE_FAILED);
  }
  return body as ApplicationLeaseCalculationResult;
};
